import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Avatar,
  Menu,
  MenuItem,
} from "@mui/material";
import { Link, useRouter } from "@tanstack/react-router";
import Logo from "./Logo";
import { useAuth } from "../context/AuthContext";

const Navbar = () => {
  const router = useRouter();
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const isActive = (path) => router.state.location.pathname === path;

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleClose();
    router.navigate({ to: "/" });
  };

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#fff",
        boxShadow: "0px 1px 0px rgba(0, 0, 0, 0.1)",
        height: "64px",
        justifyContent: "center",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between", px: 4 }}>
        {/* Logo */}
        <Link to="/" style={{ textDecoration: "none" }}>
          <Logo />
        </Link>

        {/* Navigation Links */}
        <Box sx={{ display: "flex", gap: 4 }}>
          {user && (
            <Button
              component={Link}
              to="/chat"
              sx={{
                color: isActive("/chat") ? "#000" : "#666",
                textTransform: "none",
                fontWeight: isActive("/chat") ? 600 : 400,
                fontSize: "16px",
              }}
            >
              Dashboard
            </Button>
          )}
          <Button
            component={Link}
            to="/about"
            sx={{
              color: isActive("/about") ? "#000" : "#666",
              textTransform: "none",
              fontWeight: isActive("/about") ? 600 : 400,
              fontSize: "16px",
            }}
          >
            About Us
          </Button>
          <Button
            component={Link}
            to="/contact"
            sx={{
              color: isActive("/contact") ? "#000" : "#666",
              textTransform: "none",
              fontWeight: isActive("/contact") ? 600 : 400,
              fontSize: "16px",
            }}
          >
            Contact
          </Button>
        </Box>

        {/* User Profile or Login Button */}
        {user ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography
              sx={{
                color: "#666",
                fontSize: "14px",
              }}
            >
              {user.email}
            </Typography>
            <Avatar
              onClick={handleMenu}
              sx={{
                width: 32,
                height: 32,
                bgcolor: "#F0F0F0",
                color: "#000",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              {user.email ? user.email.charAt(0).toUpperCase() : "U"}
            </Avatar>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuItem
                onClick={() => {
                  handleClose();
                  router.navigate({ to: "/profile" });
                }}
              >
                Profile
              </MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        ) : (
          <Button
            component={Link}
            to="/login"
            variant="contained"
            sx={{
              backgroundColor: "#BF2924",
              "&:hover": {
                backgroundColor: "#a61f1b",
              },
              textTransform: "none",
              fontSize: "14px",
              px: 3,
            }}
          >
            Login
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
